<template>
  <div class="m-block-info">
    <h3>概况</h3>
    <div class="infos table-shadow">
      <div class="line flex-left">
        <img src="../../../assets/img/common/blue.png" />
        <label>全部数据</label>
        <span>{{ props.infos.txCount }}</span>
      </div>
      <div class="line flex-left">
        <img src="../../../assets/img/common/green.png" />
        <label>时间 (UTC+8)</label>
        <span>{{ caculateTime(props.infos.blockTime) }}</span>
      </div>
      <div class="line flex-left">
        <img src="../../../assets/img/common/pink.png" />
        <label>默克尔根</label>
        <span>{{ filterHash(props.infos.txHash, 12) }}</span>
        <i
          class="iconfont iconfuzhi"
          v-clipboard:copy="props.infos.txHash"
          v-clipboard:success="success"
          v-clipboard:error="error"
        ></i>
      </div>
      <div class="line flex-left">
        <img src="../../../assets/img/common/blue.png" />
        <label>状态哈希</label>
        <span>{{ filterHash(props.infos.stateHash, 12) }}</span>
        <i
          class="iconfont iconfuzhi"
          v-clipboard:copy="props.infos.stateHash"
          v-clipboard:success="success"
          v-clipboard:error="error"
        ></i>
      </div>
      <div class="line flex-left">
        <img src="../../../assets/img/common/green.png" />
        <label>父区块</label>
        <span class="light block-jump" @click="jump(props.infos.height - 1)">{{
          props.infos.height - 1 >= 0 ? props.infos.height - 1 : "无"
        }}</span>
      </div>
      <div class="line flex-left">
        <img src="../../../assets/img/common/red.png" />
        <label>子区块</label>
        <span class="light block-jump" @click="jump(props.infos.height + 1)">{{
          maxHeight >= props.infos.height + 1 ? props.infos.height + 1 : "无"
        }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { caculateTime, filterHash } from "@/utils/filters";
import Store from "@/store/index";
import { useRouter } from "vue-router";
import { success, error } from "@/mixins/common";

const maxHeight = Store.state.maxHeight;
const router = useRouter();
const props = defineProps({
  infos: {
    txCount: 0,
    height: 0,
    txHash: "",
    blockTime: "",
    stateHash: "",
  },
});
function jump(height) {
  if (height < 0 || height > maxHeight) return;
  else
    router.push({
      path: "/blockdetail",
      query: { height: height },
    });
}
</script>

<style lang="scss" scoped>
.m-block-info {
  margin-top: 20px;
  h3 {
    color: $black;
    font-size: 14px;
    font-family: PingFangSC-Semibold;
    font-weight: 500;
  }
  .infos {
    margin-top: 10px;
    padding: 10px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    font-size: 12px;
    color: $black;
    .line {
      height: 38px;
      label {
        width: 105px;
        margin-left: 9px;
      }
      i {
        color: $blue;
        margin-left: 15px;
      }
    }
  }
}
</style>